module.exports = __webpack_public_path__ + "img/read_black.c90b7761.svg";